import axios from 'axios';
import { configureApis } from "@industronics/dcmm";
import { createAuthPlugin } from './react-auth-plugin';
export const authApi = axios.create({ baseURL: process.env.REACT_APP_AUTH_API_URL });

const socketApi = axios.create({
    baseURL: process.env.REACT_APP_SOCKET_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});


export const auth = createAuthPlugin({
    authBaseURL: process.env.REACT_APP_AUTH_API_URL!,
    loginURL: process.env.REACT_APP_AUTH_URL,
    devStaticAccessToken: process.env.REACT_APP_ACCESS_TOKEN
});

auth.attachAuthInterceptor(authApi);
auth.attachAuthInterceptor(socketApi);
auth.attachTaggingInterceptor(socketApi);
configureApis({
    dcmmBaseURL: process.env.REACT_APP_DCMM_BASE_URL,
    flightBaseURL: process.env.REACT_APP_FLIGHT_BASE_URL,
    timezone: "Asia/Kuala_Lumpur",
    authPlugin: auth,
});
export default socketApi;
